export class HistoricoReproducaoFiltro {
    cdFazenda: number;
    cdMatriz: number;
    cdReproducao: number;
}
